import React, { useEffect } from "react";
import CustomerHeader from "@common/components/shared/CustomerReview/CustomerHeader";
import PhotoComponent from "@common/components/shared/forms/PhotoComponent";
import { Button, Card, Form } from "semantic-ui-react";
import { FormProvider, useForm } from "react-hook-form";
import LoginAction from "@common/redux/actions/LoginAction";
import useCustomerView from "../../hooks/useCustomerView";
import useIdentityFormModal from "@common/components/hooks/useIdentityFormModal";
import useCustomerReviewModal from "../../common/components/hooks/customerInteractionAdmin/useCustomerReviewModal";

const CustomerDetails = () => {
  const {
    selectedCustomer,
    customerStatusOptions,
    fullName,
    editCustomer,
    onDeleteCustomer,
    onCustomerStatusChange,
  } = useCustomerView();
  const { customerStatus, returnDate, onSave } = useCustomerReviewModal();

  const data = useIdentityFormModal();

  const methods = useForm({
    defaultValues: data,
    mode: "all",
  });
  const { handleSubmit } = methods;

  useEffect(() => {
    LoginAction.dispatch({ isInReadMode: false });
  }, [selectedCustomer]);

  const props = {
    name: fullName,
    selectedSummaryRecord: selectedCustomer,
    customerStatus,
    customerStatusOptions,
    onCustomerStatusChange,
    optionAllowCustomerStateChange: true,
    dateOfReturn: returnDate ?? selectedCustomer?.endDateOfBreak,
    className: "mw-10em mt-1 px-1",
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(() => {})}>
        <Card className="w-100 p-1">
          <PhotoComponent onSubmit={onSave} />
          <CustomerHeader props={props} />
          <div className="text-center p-1">
            <Button
              color="green"
              onClick={() => {
                editCustomer({
                  hideName: false,
                  customer: selectedCustomer?.customer,
                });
              }}
            >
              Edit Customer
            </Button>
            <Button
              color="red"
              onClick={() => onDeleteCustomer(selectedCustomer?.customer?.id)}
            >
              Delete Customer
            </Button>
          </div>
        </Card>
      </Form>
    </FormProvider>
  );
};

export default CustomerDetails;
